import { ConfirmationDialog } from "common/styleguide/ConfirmationDialog";
import { userActions } from "data/resources/users";
import { errorMessage } from "lib/styleguide/base.scss";
import PropTypes from "prop-types";
import React, { Fragment } from "react";
import { connect } from "react-redux";

export const CONFIRM_REMOVE_FRIEND_DIALOG = "CONFIRM_REMOVE_FRIEND_DIALOG";

// core pages only, folks! This is a connected dialog.
export class _ConfirmRemoveFriend extends React.PureComponent {
  static propTypes = {
    toUnfriend: PropTypes.object.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      removePending: false,
      removeError: false,
    };
  }

  onConfirm = () => {
    const { unfriendUser, toUnfriend, onRequestClose } = this.props;

    this.setState({ removePending: true });
    unfriendUser(toUnfriend.id).then(() => this.setState({ removePending: false }, onRequestClose));
    // reminder - unfriending the user means that all of the info on the page that
    // triggered this modal will probably need to be refreshed, since the
    // permissions model will have changed!
  };

  render() {
    const { toUnfriend, onRequestClose } = this.props;
    const { removePending, removeError } = this.state;

    return (
      <ConfirmationDialog
        primary
        danger
        title={
          <Fragment>
            Un-friend <strong>{toUnfriend.name}</strong>?
          </Fragment>
        }
        maxWidth="600px"
        onRequestClose={onRequestClose}
        onCancel={onRequestClose}
        onConfirm={this.onConfirm}
        confirmPending={removePending}
        confirmText="Un-friend user"
      >
        <p>
          Are you sure you want to un-friend <strong>{toUnfriend.name}</strong>?
        </p>
        {removeError && (
          <div className={errorMessage}>
            Oops, we encountered an error while attempting to un-friend this user. Please try again.
          </div>
        )}
      </ConfirmationDialog>
    );
  }
}

const mapStateToProps = (state) => ({
  currentUser: state.currentUser,
});

const mapDispatchToProps = {
  unfriendUser: userActions.unfriend,
};

export const ConfirmRemoveFriend = connect(mapStateToProps, mapDispatchToProps)(_ConfirmRemoveFriend);
